import { branch, compose, renderNothing, withProps } from 'recompose';
import PropTypes from 'prop-types';
import React from 'react';
import { USER_TYPES } from './constants';
import withRole from './utils/withRole';
import withActiveType from './utils/withActiveType';

// if allow prop exists than deny prop does not matter
const RoleAware = ({ role, allow, children, deny, wrapperClass }) => {
  let display = false;
  if (typeof allow === 'number') {
    display = role === allow;
  } else if (typeof deny === 'number') {
    display = role !== deny;
  } else if (Array.isArray(allow)) {
    display = allow.includes(role);
  } else if (Array.isArray(deny)) {
    display = !deny.includes(role);
  }

  return (
    <div className={wrapperClass} display-if={display}>
      {children}
    </div>
  );
};

RoleAware.propTypes = {
  children: PropTypes.node,
  role: PropTypes.number.isRequired,
  allow: PropTypes.number,
  deny: PropTypes.number,
  wrapperClass: PropTypes.string,
};

RoleAware.defaultProps = {
  children: null,
  allow: null,
  deny: null,
  wrapperClass: null,
};

const RoleAwareContainer = withRole(RoleAware);
export default RoleAwareContainer;

export const RoleAwareShop = withProps({
  allow: USER_TYPES.shop,
})(RoleAwareContainer);

export const withRoleAware = compose(
  withRole,
  branch(({ role, allow, deny }) => {
    if (typeof allow === 'number') {
      return role !== allow;
    }
    if (typeof deny === 'number') {
      return role === deny;
    }
    return false;
  }, renderNothing)
);

export const RoleDenyBrand = withActiveType(({ children, type }) => (
  <div display-if={type !== 'brand'}>{children}</div>
));

export const RoleAllowBrand = withActiveType(({ children, type }) => (
  <div display-if={type === 'brand'}>{children}</div>
));

export const RoleAllowShopOrBrand = withActiveType(({ children, type }) => (
  <div display-if={type === 'brand' || type === 'shop'}>{children}</div>
));

export const RoleAllowShop = withActiveType(({ children, type }) => <div display-if={type === 'shop'}>{children}</div>);

export const RoleAllowAdmin = withProps({
  allow: [USER_TYPES.admin, USER_TYPES.regularAdmin, USER_TYPES.agent],
})(RoleAwareContainer);

export const RoleDenyAdmin = withProps({
  deny: [USER_TYPES.admin, USER_TYPES.regularAdmin, USER_TYPES.agent],
})(RoleAwareContainer);

export const RoleAllowSuperAdmin = withProps({
  allow: [USER_TYPES.admin],
})(RoleAwareContainer);
